module.exports = __webpack_public_path__ + "static/img/image@1x-5.361c8fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/image@1x-5.png
// module id = +t0i
// module chunks = 0